import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getGiftTableByShareLink } from "../../../services/sharelinkApiService";
import { fetchAndLoadGiftTable } from "../../../redux/slices/guestsGiftTableSlice";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import CoverComponent from "../components/CoverComponent";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_Guests_pages_SharePage";

const SharePage: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const { id } = useParams<{ id: string }>(); // Get the share link ID from the URL
  const dispatch = useAppDispatch();
  const [giftTableID, setGiftTableID] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchGiftTableID = async () => {
      if (!id) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await getGiftTableByShareLink(id);
        if (response?.giftTableID) {
          await dispatch(fetchAndLoadGiftTable(response.giftTableID));
          setGiftTableID(response.giftTableID);
        } else {
          setGiftTableID(null);
        }
      } catch (error) {
        console.error("Error fetching gift table ID:", error);
        setGiftTableID(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchGiftTableID();
  }, [id, dispatch]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
        <p className="mt-4">{t("sharePage.loading")}</p>
      </div>
    );
  }

  return (
    <div>
      {giftTableID ? (
        <CoverComponent giftTableID={giftTableID} />
      ) : (
        <div className="flex justify-center items-center h-screen">
          <p className="text-red-500">{t("sharePage.errorMessage")}</p>
        </div>
      )}
    </div>
  );
};

export default withTranslations(LOCALE)(SharePage);
